/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToRem, pxToEm, pxToEmWithBaseline, mediaQuery, nthChildIterator} from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION GENERAL SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  generalsection: {
    '& .collapsable.opened': {
      maxHeight: pxToRem(3000)
    }
  }
});
